import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import GlobalStyles from './styles/GlobalStyles';
import 'react-toastify/dist/ReactToastify.css';

// Safari compatibility: Add error boundary
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

// Ensure the root element exists
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found. Make sure you have a div with id="root" in your HTML.');
}

try {
  const root = ReactDOM.createRoot(rootElement);
  
  // Detect Safari
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  
  root.render(
    <React.StrictMode>
      <BrowserRouter 
        // Only use future flags on non-Safari browsers
        {...(!isSafari && {
          future: {
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }
        })}
      >
        <AuthProvider>
          <GlobalStyles />
          <App />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
} catch (error) {
  console.error('Failed to render React app:', error);
  // Safari fallback: Show error message
  rootElement.innerHTML = `
    <div style="padding: 40px; text-align: center; font-family: system-ui, -apple-system, sans-serif;">
      <h1 style="color: #C9A227; margin-bottom: 20px;">Fazyra Admin Portal</h1>
      <p style="color: #666; margin-bottom: 20px;">There was an error loading the admin portal.</p>
      <p style="color: #999; font-size: 14px;">Error: ${error.message}</p>
      <button onclick="window.location.reload()" style="margin-top: 20px; padding: 12px 24px; background: #C9A227; color: white; border: none; border-radius: 8px; cursor: pointer; font-size: 16px;">
        Reload Page
      </button>
    </div>
  `;
}
